import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { PopmtkgService } from './_service/popmtkg.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { LovComponent } from '../lov/lov.component';
import { isNullOrUndefined } from 'util';
declare var $;
@Component({
    selector: 'app-popmktg',
    templateUrl: './popmktg.component.html',
    styleUrls: ['./popmktg.component.css']
})
/** popmktg component*/
export class PopmktgComponent implements OnInit {
  /** popmktg ctor */
  public showOverlay = false;
  @ViewChild( 'lovHike' ) lovHike;
  @ViewChild( 'inputhike' ) inputhike;
 
  lovPost: any[] = [];
  constructor(private _service: PopmtkgService, public dialog: MatDialog) {}
  cstcntr: any;
  id: string; qid: string; wherecols: string; lovname: string;
  codtdesc: string;
  stcode: string;
  costcntrfo: string;
  flag: string;
  todate: number;
  fromdate: number;
  ngOnInit() {
    $(".loader-mn").hide();
  }

  getCostCentre(frmdt: string) {
    debugger;
    this._service.CostCentre(frmdt).subscribe
      (res => {
        debugger;
        if (res == 0)
        {
          debugger;
          alert('Wrong YYYYMM ')
        }

      });

  }
  comparedate(frmdt: string, todt: string) {
    debugger;
    this.todate = parseInt(frmdt, 10);
    this.fromdate = parseInt(todt, 10);
    if (this.fromdate > this.todate)
    {
      alert('From date is greater than to date ')
    }

    this._service.CostCentre(frmdt).subscribe
      (res => {
        debugger;
        if (res == 0)
        {
          debugger;
          alert('Wrong YYYYMM ')
        }




      });
  
  }
  execute(frmdt: string, todt: string, codtdesc: string) {
    debugger;
    this.showOverlay = true;
    this._service.postdata(frmdt, todt, codtdesc).subscribe
      (res => {
        debugger;
        this.showOverlay = false;
        if ( res == 1 )
        {
          alert( 'Data is Succesfuly Populated' )

        }
        else
        {
          alert( 'An Error Occur' )
        }
      });
  }

  openDialog(): void {
    debugger;
    this.id = this.lovHike.nativeElement.attributes.id.value;
    this.qid = this.lovHike.nativeElement.attributes.queryid.value;
    this.wherecols = this.inputhike.nativeElement.value;
    this.lovname = this.lovHike.nativeElement.attributes.lovname.value;

    this.lovPost.push(this.id, this.qid, this.wherecols, this.lovname);

    const dialogRef = this.dialog.open(LovComponent, {
      width: '800px',
      data: this.lovPost,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.codtdesc = result.COST_CENTER_DESC;
      this.stcode = result.STATE_CODE;
      this.costcntrfo = result.COST_CENTER_FO;

      this.lovPost = [];
      
    });
  }
}
